import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Denne funksjonen sjekker om Facebook Pixel-funksjonen (fbq) finnes
const fbq = (...args) => {
  if (window.fbq) {
    window.fbq(...args);
  } else {
    console.warn('Facebook Pixel (fbq) is not available.');
  }
};

const PixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Hver gang 'location' endrer seg (brukeren navigerer), send en PageView
    fbq('track', 'PageView');
  }, [location]);

  return null; // Denne komponenten rendrer ingenting visuelt
};

export default PixelTracker;